module.exports = __webpack_public_path__ + "img/cash-voucher.bb53fa7f.png";